var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3354",
  "data-name": "Group 3354",
  transform: "translate(-640 -571)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_42",
  "data-name": "Ellipse 42",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(640 571)",
  fill: "#2bc822"
}), /*#__PURE__*/React.createElement("path", {
  id: "path16264",
  d: "M265.67,581.052l-.231-.24a.636.636,0,0,0-.923,0l-3.921,4.081-1.391-1.447a.635.635,0,0,0-.923,0l-.231.24a.7.7,0,0,0,0,.961l2.082,2.169a.638.638,0,0,0,.923,0l4.615-4.8a.7.7,0,0,0,0-.961Z",
  transform: "translate(386.14 -4.813)",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/green-tick.b70db146.svg";
export { SvgComponent as ReactComponent };